import store from "@/plugins/store";

function Task() {




	/* these functions work without a task loaded */
	this.change_task_status = function(tasid, status) {
		// build our url parameters
		let params = new Array();
		// params.push("timesheet_kinds=true");

		// build our url, we have to add url escaping here!
		let url = "/api/tasks/" + tasid;
		if (params.length > 0) {
			url+= "?" + params.join('&');
		}

		return new Promise((resolve, reject) => {
			axios
				.put(url, {
					status: { id: status }
				}, {
					headers: {
						"Authorization": "Bearer " + store.state.token,
						"Accept": "application/json"
					}
				})
				.then(function(d) {
					// this is the result of the last search we've started, lets process it.
					let json = d.data;

					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}

					if (json.status == "OK") {
						// console.log("got data");
						resolve(json.data);
					} else {
						console.log(json.reason);
						reject(json.reason);
					}
				})
				.catch(function(e) {
					// this is the error for the last search we've started, lets show it.
					console.log(e);
					reject(e.message);
				})
		});
	}
}

export default Task;
